import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { FacilityModel } from '../_models/facility.model';
import { CustomerModel } from '../_models/customer.model';

import { environment } from '../../../../environments/environment';
import { UserService } from '../../auth/_services/user.service';

const API_FACILITY_URL = '/api/facility';
const API_URL = environment.API_URL;

@Injectable({
  providedIn: 'root'
})
export class FacilityService {

  facilityList: any[];
  facilityListChanged = new EventEmitter<any[]>();
  subheader2FacilityListChanged = new EventEmitter<any[]>();
  currencyList = [
    "AFN ؋", "ALL L", "DZD د.ج", "AOA Kz", "ARS $", "AMD ֏", "AWG ƒ", "AUD $", "AZN ₼", "BHD .د.ب",
    "BSD $", "BDT ৳", "BBD $", "BYN Br", "BZD BZ$", "BMD $", "BTN Nu.", "BOB Bs.", "BAM KM", "BWP P",
    "BRL R$", "GBP £", "BND $", "MMK K", "BIF Fr", "KHR ៛", "CAD $", "CVE $", "KYD $", "XAF FCFA",
    "XPF Fr", "CLP $", "CNY ¥", "COP $", "KMF Fr", "CDF Fr", "CRC ₡", "HRK kn", "CUC CUC$", "CUP ₱",
    "CZK Kč", "DKK kr", "DOP RD$", "DJF Fr", "XCD $", "EGP E£", "ERN Nfk", "ETB Br", "EUR €",
    "FKP £", "FJD $", "GMD D", "GEL ₾", "GHS GH₵", "GIP £", "GTQ Q", "GGP £", "GNF Fr", "GYD $",
    "HTG G", "HNL L", "HKD HK$", "HUF Ft", "ISK kr", "INR ₹", "IDR Rp", "IRR ﷼", "IQD ع.د", "ILS ₪",
    "JMD J$", "JPY ¥", "JEP £", "JOD JD", "KZT ₸", "KES Ksh", "KID $", "KGS сом", "KWD KD", "LAK ₭",
    "LBP ل.ل", "LSL L", "LRD $", "LYD LD", "MOP MOP$", "MKD ден", "MGA Ar", "MWK MK", "MYR RM", "MVR ރ.",
    "IMP £", "MRU UM", "MUR Rs", "MXN $", "MDL MDL", "MNT ₮", "MAD د.م.", "MZN MT", "NAD $", "NPR रू",
    "ANG ƒ", "TWD NT$", "NZD $", "NIO C$", "NGN ₦", "KPW ₩", "NOK kr", "OMR ر.ع.", "PKR Rs", "PAB B/.",
    "PGK K", "PYG ₲", "PEN S/.", "PHP ₱", "PLN zł", "QAR ر.ق", "RON lei", "RUB ₽", "RWF Fr", "SHP £",
    "WST WS$", "STN Db", "SAR ر.س", "RSD din", "SLL Le", "SGD $", "SOS Sh", "SLS Sl", "ZAR R", "KRW ₩",
    "SSP £", "SRD $", "SEK kr", "CHF Fr", "LKR Rs", "SZL E", "SYP £", "TJS ЅМ", "TZS TSh", "THB ฿",
    "TOP T$", "PRB R", "TTD TT$", "TND د.ت", "TRY ₺", "TMT T", "TVD $", "UGX USh", "UAH ₴", "AED د.إ",
    "USD $", "UYU $", "UZS soʻm", "VUV VT", "VES Bs.", "VND ₫", "XOF CFA", "ZMW ZK", "ZWB Z$"
  ];

  constructor(private readonly http: HttpClient,
    private readonly userService: UserService) { }

  emptyFacility() {
    this.facilityList = [];
    this.facilityListChanged.emit([]);
  }

  getFacility(observableFlag = false, moduleType = '', generation = null, fields='') {
    let params = {}
    if (generation) {
      params["generation"] = generation
    }
    let url = API_URL + API_FACILITY_URL
    if (fields) {
      params['fields'] = fields
    }
    if (observableFlag) {
      return this.http.get(url, { params: params, headers: this.userService.getHttpAuthHeader() });
    }
    this.http.get(url, { params: params, headers: this.userService.getHttpAuthHeader() }).subscribe((data: any) => {
      this.facilityList = data.data;
      this.facilityListChanged.emit(data.data);
      if (moduleType === 'dashboard') {
        this.subheader2FacilityListChanged.emit(data.data)
      }
    });
  }

  getFacilityById(id: string, fields='') {
    let httpParams = new HttpParams();
    if (id) {
      httpParams = httpParams.set('_id', id);
    }
    if (fields) {
      httpParams = httpParams.set('fields', fields);
    }
    let url = API_URL + API_FACILITY_URL;
    return this.http.get(url, { params: httpParams, headers: this.userService.getHttpAuthHeader() });
  }

  getFacilityByEnterprise(id: any, observableFlag = false, fields = null) {
    let url = API_URL + API_FACILITY_URL;

    let httpParams = new HttpParams()
    if (id) {
      httpParams = httpParams.set('enterprise', id);
    }


    if (fields) {
      httpParams = httpParams.set('fields', fields);
    }

    if (observableFlag) {
      return this.http.get(url, { params: httpParams, headers: this.userService.getHttpAuthHeader() });
    }

    this.http.get(url, { params: httpParams, headers: this.userService.getHttpAuthHeader() }).subscribe((data: any) => {
      this.facilityList = data.data;
      this.facilityListChanged.emit(data.data);
    });
  }

  createFacility(f: Partial<FacilityModel>, observableFlag = false) {

    let facility = {
      location: f.location,
      type: f.type,
      capacity: f.capacity,
      plantCode: f.plantCode,
      application: f.application,
      currency: f.currency,
      notes: f.notes,
      name: f.name.trim(),
      customerAdvocate: f.customerAdvocate,
      enterprise: f.enterprise,
      region: f.region,
      dataFetchSetting: f.dataFetchSetting,
      predictionSetting: f.predictionSetting,
      dqSettings: f.dqSettings,
      timezone: f.timezone,
      zoomLevel: f.zoomLevel,
      cmmsWriteIntegration: f.cmmsWriteIntegration,
      last_sap_pulled_at: f.last_sap_pulled_at,
      plantEconomics: f.plantEconomics,
      //organization: f.organization
      //system: []
    }

    if (observableFlag) {
      return this.http.post<FacilityModel>(API_URL + API_FACILITY_URL, facility, { headers: this.userService.getHttpAuthHeader() });
    }

    this.http.post<FacilityModel>(API_URL + API_FACILITY_URL, facility, { headers: this.userService.getHttpAuthHeader() }).subscribe((data: any) => {
      this.userService.getCurrentUser();
      this.getFacility();
    });
  }

  updateFacility(f: Partial<FacilityModel>, observableFlag = false) {
    let facility = {
      _id: f._id,
      location: f.location,
      type: f.type,
      capacity: f.capacity,
      plantCode: f.plantCode,
      application: f.application,
      currency: f.currency,
      notes: f.notes,
      name: f.name.trim(),
      customerAdvocate: f.customerAdvocate,
      enterprise: f.enterprise,
      region: f.region,
      // dataFetchSetting: f.dataFetchSetting,
      predictionSetting: f.predictionSetting,
      dqSettings: f.dqSettings,
      timezone: f.timezone,
      zoomLevel: f.zoomLevel,
      cmmsWriteIntegration: f.cmmsWriteIntegration,
      last_sap_pulled_at: f.last_sap_pulled_at,
      plantEconomics: f.plantEconomics,
      //organization: f.organization
      //system: []
    }

    if (observableFlag) {
      return this.http.put<FacilityModel>(API_URL + API_FACILITY_URL, facility, { headers: this.userService.getHttpAuthHeader() });
    }

    this.http.put<FacilityModel>(API_URL + API_FACILITY_URL, facility, { headers: this.userService.getHttpAuthHeader() }).subscribe((data: any) => {
      this.getFacility();
    });
  }

  /*  deleteFacility(f: FacilityModel, cb?:any) {

     this.http.delete<FacilityModel>(API_URL + API_FACILITY_URL + '?_id=' + f._id, { headers: this.userService.getHttpAuthHeader() }).subscribe((data: any) => {
       if(cb){
         return cb();
       }
       this.getFacility();
     });
   }
  */
  deleteFacility(f: any) {
    return this.http.delete<FacilityModel>(API_URL + API_FACILITY_URL + '?_id=' + f, { headers: this.userService.getHttpAuthHeader() });
  }

}